import { createFileRoute } from '@tanstack/react-router';
import { LeaveBehindPage } from '@/components/leave-behind/LeaveBehindSheet';
import { LEAVE_BEHIND_ES } from '@/lib/leave-behind';

function LeaveBehindSpanishPage() {
  return <LeaveBehindPage copy={LEAVE_BEHIND_ES} />;
}

export const Route = createFileRoute('/leave-behind/es')({
  component: LeaveBehindSpanishPage,
});
